export const home = {
  home_profile_selector_text: 'Select a profile',
  home_profile_selector_subtitle: 'Choose your profile to continue your registration.',
  home_has_account_true: 'No, I already participate',
  home_has_account_false: 'Yes, I join the study!',
  home_is_new: 'Are you new?',
  home_forgot_password: 'Forgot password?',
  home_inscription_title: 'Registration',
  home_consent_title: 'Consent',
  home_consent_expired_title: 'This consent page has expired',
  home_consent_expired_description: 'It stayed open too long. Go back to the previous step to load the consent again and continue your registration.',
  home_consent_item_required: 'required',
  home_consent_item_optional: 'optional',
  home_consent_items_mismatch: 'The consent has been updated. Please review and confirm the checkboxes again.',
  home_content_check_text: 'By checking this box, I confirm that I agree with all the terms of the information document',
  home_content_none_text: 'No consent',
  home_not_consent_text: 'I do not agree with all the terms',
  home_content_signature_text: 'Sign below to give your consent',
  home_inclusion_placeholder: 'Select one',
  home_inclusion_answer_true: 'Yes',
  home_inclusion_answer_false: 'No',
  home_inclusion_on: 'About you',
  home_inclusion_off: 'No inclusion question',
  home_identifier_title: 'Choose your identifier',
  home_contact_title: 'Contact you',
  home_contact_description: 'For the study to work, you will receive reminders and info up to 2 times a month.',
  home_inscription_identifier: 'Email or nickname',
  home_inscription_firstname: 'First name',
  home_inscription_lastname: 'Last name',
  home_inscription_nickname: 'Nickname',
  home_inscription_email: 'Email',
  home_inscription_phone: 'Phone',
  home_inscription_external_id: 'File number',
  home_inscription_address: 'Address',
  home_inscription_birthdate: 'Date of birth',
  home_inscription_off: 'No identification',
  home_secret_questions: 'Secret questions',
  home_secret_question_date_placeholder: 'Select a date',
  home_secret_question_number_placeholder: 'Enter number',
  home_secret_question_text_placeholder: 'Enter text',
  home_password_title: 'Create your password',
  home_password_placeholder: 'Password',
  home_password_placeholder_confirm: 'Confirm password',
  home_login_email_placeholder: 'Email',
  home_login_nickname_placeholder: 'Nickname, email or phone',
  home_login_identifier_placeholder: 'Nickname, email, phone or file number',
  home_login_file_placeholder: 'Enter file number',
  home_password_description: 'The password must be at least 8 characters long and contain uppercase, lowercase, symbols, and numbers.',
  home_login_title: 'Login',
  home_login_subtitle: 'Nice to see you again!',
  home_login_incorrect: 'Your username or password is incorrect.',
  home_login_too_many_attempts: 'Too many login attempts. For your security, please wait a few minutes before trying again.',
  home_login_button: 'Login',
  home_login_password_placeholder: 'Your password',
  home_stratification_title: '',
  home_stratification_placeholder: 'Select one',
  home_sites_text: 'Site affiliation',
  home_subsites_text: 'Sub-site affiliation',
  home_do_you_have_account: 'Do you have an account?',
  home_researchers_website: 'Researchers Website',
  home_registred_successfully: 'Congratulations, you are successfully registered.',
  home_inscription_error_EMAIL_EXIST: 'An account with this email already exists',
  home_inscription_error_NICKNAME_EXIST: 'An account with this nickname already exists',
  home_inscription_error_EXTERNAL_ID_UNKNOWN: 'Case number not recognized — check the number given by the team',
  home_family_title: 'Your family',
  home_family_count_fallback: 'How many "{{role}}" are in your family?',
  home_inscription_contact_verification_description: 'Enter the 6-digit codes we sent to confirm your contact details.',
  home_inscription_contact_verified: 'Verified',
  home_inscription_contact_verification_success: 'Your contact details are verified.',
  home_inscription_email_verification_request_error: 'Error sending the email verification code',
  home_inscription_email_verification_error: 'Error verifying the email code',
  home_inscription_phone_verification_request_error: 'Error sending the SMS verification code',
  home_inscription_phone_verification_error: 'Error verifying the SMS code',

  // Randomisation errors
  home_randomisation_no_slots: 'Registration is currently full for your group. Please try again later or contact the study team.',
  home_randomisation_no_matching_group: 'No randomisation group matches your profile. Please contact the study team.',
  home_randomisation_invalid_case_code: 'This case number was not found. Please check it and try again.',
  home_randomisation_unsupported: 'This study uses a registration method that is not yet supported. Please contact the study team.',
  home_randomisation_site_required: 'Please select your site before giving your consent.',

  // Case code step
  home_case_code_title: 'Case number',
  home_case_code_description: 'Enter the case number (file number) you were given.',
  home_case_code_placeholder: 'Case number',

  // Synakene Addition
  home_welcome: "Welcome to {{appName}}!",
  home_description: "Check in on yourself with {{appName}}!",
  home_partners_caption: "Supported by",
  home_anonymous_data: "Your data is confidential; researchers will not have access to your identity.",
  home_new: "Are you new?",
  home_copy_link: "Copy the study link",
  home_copied: "The link has been successfully copied!",
  not_eligible_but_try_the_app: "No, I am not between 11 and 24 years old, but I would like to discover the app",

  home_not_included: "Thank you for your interest, but you must be between 11 and 24 years old and live in France.",
  home_not_included_desc: "To help us, you can share the study with those around you.",
  home_nir_title: 'Your social security number',
  home_nir_explanation_snds: 'Used solely to link the study with the national health data system (SNDS). Encrypted, stored separately, never visible to the research team.',
  home_nir_placeholder: '15 digits, as printed on your carte Vitale',
  home_nir_input_placeholder: 'e.g. 2 85 05 78 006 048 22',
  home_nir_field_label: 'Social security number (NIR)',
  home_nir_optional_label: 'Optional',
  home_nir_error_conflict: 'This social security number is already linked to another participant of this study.',
};

